export function observer(target, type, callback, options = {}) {
  let observer;

  switch (type) {
  case 'mutation':
    observer = new MutationObserver(callback);
    observer.observe(target, options);
    break;
  case 'intersection':
    observer = new IntersectionObserver(callback, options);
    observer.observe(target);
    break;
  case 'resize':
    observer = new ResizeObserver(callback);
    observer.observe(target);
    break;
  default:
    console.error('#observer The type provided is invalid.');
  }

  function stop() {
    observer.disconnect();
    observer = undefined;
  }

  return stop;
}
